module.exports = __webpack_public_path__ + "static/img/welfare.c78efedf.png";